import { useEffect, useState } from 'react';
import MainContentWrapper from '../../../Components/MainContentWrapper';
import dateFormat from 'dateformat';
import TableView from '../../../ReusableComponents/TableView/TableView';
import Popup from '../../../ReusableFunctions/Popup';
import DashBoardCard from '../../../features/HomePage/SubComponents/DashBoardCard/DashBoardCard';
import { useNavigate } from 'react-router';
import { getUserInvoices, getUserInvoicesStats } from '../../../apis/adminAPIs/finance/userInvoices';
import { PAYMENT_STATUSES, STATUS } from '../../../appConstants';
import { PDRL_FINANCE_ROUTES } from '../../../routes';
import Search from '../../../ReusableComponents/Search';
import UserInvoicesFilter from './UserInvoicesFilter';
import { Button } from '../../../Components/Helper';
import Filter from "../../../assets/filter.svg"
import Loading from '../../../ReusableFunctions/Loader';
import * as XLSX from 'xlsx';
import SelectComponent from '../../../ReusableComponents/SelectComponent';

const InvoicesStatCard = ({ title, statNumber, isSelected, onClick, isDisabled }) => {
    return <DashBoardCard
        isDisabled={isDisabled}
        title={title}
        data={statNumber}
        onClick={onClick}
        backGround={isSelected ? "green" : undefined}
    />
}

const InvoiceStats = ({ invoicesStats, filters, changeStatusFilter, isDisabled }) => {
    return <div style={{ display: "flex", columnGap: "2%" }}>
        <InvoicesStatCard
            isDisabled={isDisabled}
            title={`Total (₹${(invoicesStats.total_billed_to_customer).toFixed()}, CN - ₹${invoicesStats.total_coupon_amount.toFixed()})`}
            statNumber={invoicesStats.total_invoices_count}
            isSelected={filters.statuses.length === 0}
            onClick={() => changeStatusFilter([])}
        />
        {!isDisabled &&<>
        <InvoicesStatCard
            isDisabled={isDisabled}
            title={`Paid (₹${(invoicesStats.paid_invoices_amount).toFixed()}, CN - ₹${invoicesStats.total_coupon_paid_amount.toFixed()})`}
            statNumber={invoicesStats.paid_invoices_count}
            isSelected={filters.statuses.length > 0 && filters.statuses[0] === PAYMENT_STATUSES.PAID}
            onClick={() => changeStatusFilter([PAYMENT_STATUSES.PAID])}
        />
        
        <InvoicesStatCard
            isDisabled={isDisabled}
            title={`Unpaid (₹${(invoicesStats.unpaid_invoices_amount).toFixed()}, CN - ₹${invoicesStats.total_coupon_unpaid_amount.toFixed()})`}
            statNumber={invoicesStats.unpaid_invoices_count}
            isSelected={filters.statuses.length > 0 && filters.statuses[0] === STATUS.COMPLETED}
            onClick={() => changeStatusFilter([STATUS.COMPLETED])}
        />
        </>
        }
        
    </div>
}

const UserInvoices = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true)
    const [userInvoices, setUserInvoices] = useState([])
    const [invoicesStats, setInvoicesStats] = useState({
        total_billed_to_customer : 0,
        total_coupon_amount : 0,
        total_invoices : 0,
        total_invoices_count_for_pagination: 0,
        coupon_paid_invoices_count : 0,
        coupon_unpaid_invoices_count : 0,
        total_invoices_count: 0,
        paid_invoices_count: 0,
        total_coupon_paid_amount : 0,
        unpaid_invoices_count: 0,
        paid_invoices_amount: 0,
        unpaid_invoices_amount: 0,
        total_paid_amount : 0,
        total_unpaid_amount:0,
        total_coupon_unpaid_amount : 0,
        paid_invoices_count_untill_to_date : 0,
        coupon_paid_invoices_count_untill_to_date : 0,
        total_paid_amount_untill_to_date : 0,
        total_coupon_paid_amount_untill_to_date : 0,
        total_unpaid_amount_untill_to_date : 0,
        total_coupon_unpaid_amount_untill_to_date : 0
    })
    const [filters, setFilters] = useState(()=>{

        let savedFilters=localStorage.getItem('UserInvoicesFilters');
        if(savedFilters) {
            let parsedFilters=JSON.parse(savedFilters);
            return {
                ...parsedFilters,
                fromDate: parsedFilters.fromDate ? new Date(parsedFilters.fromDate).toISOString() : null,
                toDate: parsedFilters.toDate ? new Date(parsedFilters.toDate).toISOString() : null,
            }
        }
        return {
            pageNumber: 1,
            pageSize: 20,
            orderType: "DESC",
            statuses: [PAYMENT_STATUSES.PAID],
            searchString: undefined,
            fromDate: undefined,
            toDate: undefined,
            paymentMode: undefined,
            states: [],
        }
    })
    const [openFilter, setOpenFilter] = useState(false)

    const getUserInvoicesFunc = async () => {
        try {
            setIsLoading(true)
            const invoices = await getUserInvoices(filters.fromDate, filters.toDate, filters.pageSize, filters.pageNumber, filters.orderType, filters.statuses, filters.searchString, filters.paymentMode,filters.states)
            const invoicesStats = await getUserInvoicesStats(filters.fromDate, filters.toDate, filters.searchString, filters.paymentMode,filters.states)
            setInvoicesStats({
                ...invoicesStats,
                total_invoices_count_for_pagination: filters?.statuses[0] ? (filters?.statuses[0] === STATUS.PAID ? (invoicesStats.paid_invoices_count || 0) : (invoicesStats.unpaid_invoices_count || 0)) : (invoicesStats.total_invoices || 0),
                total_invoices_count: invoicesStats.total_invoices || 0,
                paid_invoices_count: invoicesStats.paid_invoices_count || 0,
                unpaid_invoices_count: invoicesStats.unpaid_invoices_count || 0,
                paid_invoices_amount: invoicesStats.total_paid_amount || 0,
                unpaid_invoices_amount: invoicesStats.total_unpaid_amount || 0,
                total_billed_to_customer : invoicesStats.total_billed_to_customer ? Number(invoicesStats.total_billed_to_customer) : 0
            })


            setUserInvoices(invoices)
            setIsLoading(false)
        } catch (e) {
            console.error(e)
            Popup.alert("ERROR", "We cant load invoices right now, Please try again later.")
        }
    }

   const downloadCreditNoteExcel = async () => {
    try {
        Loading.set(true);
        const invoices = await getUserInvoices(filters.fromDate, filters.toDate, undefined, undefined, filters.orderType, filters.statuses, filters.searchString, filters.paymentMode, filters.states);
        const filteredInvoices = invoices?.filter(invoice => Number(invoice?.applied_bhumeet_coupon_total_amount) > 0);
        const worksheet = XLSX.utils.json_to_sheet(filteredInvoices?.map((invoice, index) => (
            {
                "REFERANCE NO": invoice?.credit_note?.cr_number,
                'SUPPLIER INV NO': invoice?.invoice_number,
                'INVOICE DATE': dateFormat(invoice.service_completed_time, "dd/mm/yyyy"),
                'GST NO': "",
                'PARTY A/C NAME': invoice?.to?.name || 'N/A',
                'PLACE OF SUPPLY': invoice?.state || '-',
                'PARTICULARS': 'Credit Note',
                'AMOUNT': Number(invoice?.applied_bhumeet_coupon_total_amount).toFixed(2),
                'SGST': 0,
                "CGST": 0,
                "IGST": 0,
                "TOTAL AMOUNT": (Number(invoice?.applied_bhumeet_coupon_total_amount)).toFixed(2),
            }
        )));
        // Set the column widths
        const columnWidths = [
            { wch: 10 },
            { wch: 20 },
            { wch: 15 },
            { wch: 10 },
            { wch: 40 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 10 },
            { wch: 10 },
            { wch: 10 },
            { wch: 15 }
        ];

        worksheet['!cols'] = columnWidths;
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoices');
        XLSX.writeFile(workbook, 'creditNote.xlsx');
    } catch (err) {
        console.error("error :", err);
        Popup.alert("ERROR", "We can't download excel right now, Please try again later.");
    } finally {
        Loading.set(false);
    }
}
    const downloadExcel = async() => {
        try{
            Loading.set(true);
            const invoices =await getUserInvoices(filters.fromDate, filters.toDate, undefined,undefined, filters.orderType, filters.statuses, filters.searchString, filters.paymentMode,filters.states)
            const worksheet = XLSX.utils.json_to_sheet(invoices?.map((invoice,index) => ({
                "REFERANCE NO":index+1,
                'SUPPLIER INV NO': invoice.invoice_number,
                'INVOICE DATE': dateFormat(invoice.service_completed_time, "dd/mm/yyyy"),
                'GST NO':"",
                'PARTY A/C NAME':invoice?.to?.name || 'N/A',
                'PLACE OF SUPPLY':invoice?.state || '-',
                'PARTICULARS':'Sales',
                'AMOUNT':Number(invoice.total_amount_without_bhumeet_coupon).toFixed(2),
                'SGST':0,
                "CGST":0,
                "IGST":0,
                "TOTAL AMOUNT":(Number(invoice?.total_amount_without_bhumeet_coupon)).toFixed(2),
            })));
            // Set the column widths
            const columnWidths = [
                { wch: 10 }, 
                { wch: 20 }, 
                { wch: 15 }, 
                { wch: 10 }, 
                { wch: 40 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 10 },
                { wch: 10 },
                { wch: 10 },
                { wch: 15 }
            ];
    
            worksheet['!cols'] = columnWidths;
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoices');
            XLSX.writeFile(workbook, 'customerInvoice.xlsx');
        }catch(err){
         console.error("error :",err);
         Popup.alert("ERROR", "We cant download excel right now, Please try again later.")
        }finally{
            Loading.set(false);
        }
    };
    // useEffect(() => {
    //     getUserInvoicesFunc()
    //    let getstoredState =  localStorage.getItem('UserInvoicesFilters')
    //     if(getstoredState){
    //         setFilters(JSON.parse(getstoredState))
    //     }

    // }, [])

    useEffect(()=>{
    let timer;
    timer=setTimeout(()=>{getUserInvoicesFunc()},500)
    return ()=>clearTimeout(timer);
    },[filters.searchString])

    useEffect(() => {
        getUserInvoicesFunc()
        localStorage.setItem('UserInvoicesFilters',JSON.stringify(filters))
    }, [filters.pageNumber,filters.orderType,filters.statuses,filters.fromDate,filters.toDate,filters.paymentMode,filters.states])




    return <>
        <MainContentWrapper header={`Customer Invoices`} rightContent={
            <div style={{ display: "flex", gap: '30px' }}>
                <Search
                    searchValue={filters.searchString}
                    onChange={(value) => {
                        setFilters({
                            ...filters,
                            pageNumber: 1,
                            searchString: value
                        })
                    }}
                    placeholder={"Search by Invoice No."}
                />
                    <SelectComponent
                    controlStyle={{ height: "40px", width: "200px", minHeight: "20px", border: "none", boxShadow: "0px 2px 5px 1px #6273943d", color:"black", fontSize: "12px",fontWeight:600 }}
                    placeholder={"Export Execl"}
                    menuPlacement={"bottom"}
                    list={["Export Invoices","Export Credit Note"].map((opt)=>({label:opt,value:opt}))}
                    value={"Export Excel"}
                    onChange={({label,value}) => {
                        console.log("value",value);
                         if(value==="Export Invoices"){
                            downloadExcel();
                         }
                         else {
                            downloadCreditNoteExcel();
                         }
                    }}
                />
               
                 
                <Button
                    innerClassName={"filter-btn-inner"}
                    iconStyle={{ width: "18px", marginRight: "10px" }}
                    text={"Filter"}
                    icon={Filter}
                    className={"filter-btn"}
                    onClick={() => {
                        setOpenFilter(true)
                    }}
                    textClassName={"user-details-filter-text"}
                />
            </div>}
        >
            <InvoiceStats
                isDisabled={filters.paymentMode === STATUS.CANCELLED}
                invoicesStats={invoicesStats}
                filters={filters}
                changeStatusFilter={(statusFiler) => setFilters({ ...filters, statuses: statusFiler, pageNumber: 1 })}
            />
            {openFilter &&
                <UserInvoicesFilter
                    filter={filters}
                    onFilterChange={(appliedFilters) => {
                        setFilters({
                            ...appliedFilters,
                            pageNumber: 1
                        })
                        setOpenFilter(false)
                    }}
                    open={openFilter}
                    onClose={() => {
                        setOpenFilter(false)
                    }}
                />
            }
            <div style={{
                margin: "20px 0",
                height: "72%"
            }}>
                <TableView
                    showSrNo
                    loadingHeight={"500px"}
                    isLoading={isLoading}
                    onStateChange={async (changedState) => {
                        const { pageNumber, orderBy, orderType } = changedState;
                        setFilters({ ...filters, pageNumber, orderBy, orderType });
                    }}
                    onClickRow={(invoice) => {
                        navigate(`${PDRL_FINANCE_ROUTES.USER_INVOICE_DETAILS}`, {
                            state: {
                                invoice
                            }
                        })
                    }}
                    columns={[
                        { Header: "Invoice No.", accessor: "invoice_number" },
                        { Header: "Total Amount (₹)", accessor: "total_amount_without_bhumeet_coupon" },
                        { Header: "Paid Amount (₹)", accessor: "total_amount" },
                        { Header: "Date", accessor: "service_completed_time", isDate: true, isSortable: true, format: "dd/mm/yyyy" },
                        { Header: "Status", accessor: "status" }
                    ]}
                    count={invoicesStats.total_invoices_count_for_pagination}
                    pageSize={filters.pageSize}
                    pageNumber={filters.pageNumber}
                    data={userInvoices.map((uI) => {
                        return {
                            ...uI,
                            total_amount_without_bhumeet_coupon:Number(uI.total_amount_without_bhumeet_coupon).toFixed(2),
                            total_amount: Number(uI.total_amount).toFixed(2),
                            status: uI.status === STATUS.PAID ? "Paid" : "Unpaid"
                        }
                    })}
                    tableContainerHeight={"100%"}
                    hidePagination={false}
                    headerStyle={{ zIndex: 0 }}
                />
            </div>
        </MainContentWrapper>
    </>
}
export default UserInvoices